export const environment = {
  production: false,
  apiUrl: 'https://mytm-dev-api.faktory.digital/dev',
  cognitoUserPoolId: 'eu-west-1_p7IukPOHg',
  cognitoClientId: '2pgc96bd9o2u2mg0ug5eog1153',
  cognitoDomain: 'mytm-dev.auth.eu-west-1.amazoncognito.com',
  photosBucket: 'truckmanager-dev-photos',
  region: 'eu-west-1',
};
